import Svg, { Path } from 'react-native-svg'
export const MoreIcon = ({ height = 24, width = 24, color = '#fff' }) => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
      <Path
        fill={color}
        d="M12 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm0 10a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm0-6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"
      />
    </Svg>
  )
}
